import {loadMasks} from "../functions";

class Servico {

  static aplicarLancamento($this) {

    $this.prop('disabled', true);

    if ($('#empresa').length > 0) {
      $('.preloader').show();
    }

    const $id = $('#id');
    const $empresa = $('#empresa');
    const $servico = $('#servico');
    const $vencimento = $('#vencimento');
    const $valor = $('#valor');
    const $recorrente = $('#recorrente');
    const $parcelamento = $('#parcelamento');
    const $observacoes = $('#observacoes');

    $.ajax({
      type: 'POST',
      url: `/servicos`,
      data: {
        id: $id.val(),
        empresa_id: $empresa.val(),
        id_servico: $servico.val(),
        vencimento: $vencimento.val(),
        valor: $valor.val().replace(/\./g, '').replace(',', '.'),
        recorrente: $recorrente.val(),
        parcelamento: $parcelamento.val(),
        observacoes: $observacoes.val(),
        tipo: $('#tipo').val(),
      }
    }).done(response => {
      Swal.fire({
        icon: 'success',
        title: 'Sucesso!',
        html: `O serviço foi salvo com sucesso.`,
      }).then(result => {
        if (result) {
          $('.preloader').show();
          window.location = response.url;
        }
      });

    }).fail(response => {

      let errorHTML = response.responseText;

      if (response.status === 412) {

        const errors = (response.responseJSON.errors);

        let messages = [];
        let $firstFocus = null;

        for (let error in errors) {
          if (!$firstFocus) {
            $firstFocus = $(`#${error}`);
          }
          $(`#${error}`).closest('.form-group').addClass('invalid-data');
          messages.push(`<li>${errors[error]}</li>`);
        }

        const acao = parseInt($id.val()) === 0 ? 'cadastrar' : 'alterar';

        errorHTML = `
            Não foi possível ${acao} o serviço.
            <br>Verifique os campos em vermelho.
          `;
      }

      Swal.fire({
        icon: 'error',
        title: 'Erro!',
        text: errorHTML,
      });
    }).always(() => {
      $this.prop('disabled', false);
      $('.preloader').hide();
    });
  }

  static excluirLancamento($this) {
    Swal.fire({
      icon: 'error',
      title: 'Aviso!',
      html: `Deseja realmente excluir este Serviço?<br>
       - Sua exclusão poderá afetar retroativamente os relatórios;<br>
      - Caso seja recorrente o mesmo continuará nos meses anteriores.
      `,
    }).then(result => {
      if (result) {
        $('.preloader').show();
        $.ajax({
          type: 'DELETE',
          url: `/servicos/${$this.val()}`
        }).done(function (response) {
          Swal.fire({
            icon: 'success',
            title: 'Sucesso!',
            html: `O serviço foi excluído!`,
          });
          window.location.reload();
        });
      }
    });
  }

  static listen() {
    jQuery(function () {
      loadMasks();

      $('input, select').closest('.form-group').addClass('focused');

      $(document).on('change', '#empresa', function (e) {
        $('.aplicar-cobranca').val($(this).val())
      });

      $(document).on('change', '#servico', function (e) {
        var $this = $(this);
        var servico = window.dadosServicos.filter(servico => {
          return servico.id === parseInt($this.val());
        })[0];

        if (servico) {
          $('#valor').val(servico.valor).trigger('input');
        }
      });

      $(document).on('click', '.aplicar-lancamento', function (e) {
        const $this = $(this);
        e.preventDefault();
        Servico.aplicarLancamento($this);
      });

      $(document).on('click', '.excluir-lancamento', function (e) {
        const $this = $(this);
        Servico.excluirLancamento($this);
      });
    });
  }
}

export default Servico;
